import { Icon, IconProps } from "../";

export const Kevlar = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 56 56" {...props}>
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.1046 18.6595H13.9961V43.5588H17.1046V46.6673H38.8954V43.5588H42.0039V18.6595H38.8954V9.33398H35.7557V18.6595H32.6783V15.551H23.3216V18.6595H20.2442V9.33398H17.1046V18.6595ZM20.2442 28.0162H35.7557V31.0936H20.2442V28.0162ZM20.2442 34.2332V37.3106H35.7557V34.2332H20.2442Z"
          fill="currentColor"
        />
      </>
    </Icon>
  );
};
